import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BoardViewFill = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path d="M14 3H9V11C9 11.5523 9.44772 12 10 12L13 12C13.5523 12 14 11.5523 14 11V3Z" fill="white" />
        <path d="M7 3H2V13C2 13.5523 2.44772 14 3 14L6 14C6.55228 14 7 13.5523 7 13V3Z" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 3H6.49998L6.49998 13.5H2.5L2.5 3ZM1.5 3C1.5 2.44772 1.94772 2 2.5 2H6.49998C7.05227 2 7.49998 2.44772 7.49998 3V13.5C7.49998 14.0523 7.05227 14.5 6.49998 14.5H2.5C1.94771 14.5 1.5 14.0523 1.5 13.5V3ZM9.49998 3H13.5V11H9.49998V3ZM8.49998 3C8.49998 2.44772 8.9477 2 9.49998 2H13.5C14.0523 2 14.5 2.44772 14.5 3V11C14.5 11.5523 14.0523 12 13.5 12H9.49998C8.9477 12 8.49998 11.5523 8.49998 11V3Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default BoardViewFill
